import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ContactEmailDetails } from './contact.model';


@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(
        private http: HttpClient,
  ) {}

  /**
   * Send a 'Contact Us' email to the support team
   * @param contactEmail
   * @returns {Observable<Object>}
   */
  sendContactEmail(contactEmailDetails: ContactEmailDetails): Observable<any> {
    return this.http.put<any>(`${environment.apiBaseURL}/support/send-email`, contactEmailDetails);
  }
}
